<ng-container *ngIf="hasData; else emptyState">
	<section class="section-header">
		<div class="header-content">
			<div class="header-left">
				<i class="fa-solid fa-chart-pie"></i>
				<div class="header-text">
					<h1>Ratios Financieros Anuales</h1>
					<p class="header-subtitle">Indicadores derivados (Liquidez, DSCR, ROE, EBITDA, etc.)</p>
				</div>
			</div>
			<div class="header-right">
				<p-tag [value]="periods.length + (periods.length === 1 ? ' periodo' : ' periodos')" severity="info"></p-tag>
			</div>
		</div>
	</section>

	<section class="info-card">
		<div class="card-header">
			<i class="fa-solid fa-table"></i>
			<h3>Ratios por Período</h3>
		</div>
		<div class="card-content">
			<table class="data-table">
				<thead>
					<tr>
						<th>Ratio</th>
						<th class="num" *ngFor="let p of periods; trackBy: trackByPeriod">{{ p.year }}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of mergedRows; trackBy: trackByRowIndex"
						[class.category]="row.isCategory">
						<td class="concept" [style.padding-left.px]="12 + row.indent * 16">{{ row.label }}</td>
						<td class="num" *ngFor="let p of periods">
							<ng-container [ngSwitch]="row.format">
								<span *ngSwitchCase="'percentage'">{{ getValue(p, row.rowIndex) | percent:'1.2-2' }}</span>
								<span *ngSwitchCase="'currency'">{{ getValue(p, row.rowIndex) | currency:'MXN':'symbol-narrow':'1.2-2' }}</span>
								<span *ngSwitchDefault>{{ getValue(p, row.rowIndex) | number:'1.2-2' }}</span>
							</ng-container>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</section>
</ng-container>

<ng-template #emptyState>
	<div class="empty-state">
		<i class="fa-solid fa-file-arrow-up"></i>
		<h3>Sin datos de Ratios Anuales</h3>
		<p>Sube el Excel de Análisis de Riesgo arriba para ver los ratios financieros.</p>
	</div>
</ng-template>
